module.exports = "/_next/static/images/call-4a0aeee280cedf5794ab1e457b2ba21e.svg";